import './main.scss';
import 'whatwg-fetch';
import 'mdn-polyfills/CustomEvent';
import 'mdn-polyfills/Element.prototype.closest';
import 'mdn-polyfills/Element.prototype.matches';
import Navigo from 'navigo';
import merge from 'lodash/merge';
import escapeRegExp from 'lodash/escapeRegExp';
import { initStatus } from '@legacynotes/frontend/src/components/status/status';
import { initParagraph } from '@legacynotes/frontend/src/components/paragraph/paragraph';
import { initSearch } from '@legacynotes/frontend/src/components/search/search';

class Assistant {
	constructor(element, options = {}) {
		this.element = element;
		this.options = merge(
			{
				url: window.__url__, // See `rollup.config.js`
				path: '/assistant',
				error: `Inhalt konnte nicht geladen werden`,
				locale: 'de'
			},
			options
		);

		this.init();
	}

	/**
	 * Load initial data and capture click events
	 */
	init() {
		// Load root content
		this.load();

		// Init router
		this.router = new Navigo('/', { hash: true });

		this.router
			.on('/', () => {
				this.load();
			})
			.on('/assistant', () => {
				this.load();
			})
			.on('/assistant/:id', ({ url, hashString }) => {
				this.load(hashString || url || undefined);
			})
			.resolve();

		// Hijack links
		this.element.addEventListener('click', event => {
			const link = event.target.matches('a') ? event.target : event.target.closest('a');

			if (link) {
				const href = link.getAttribute('href');
				const pattern = new RegExp(`^${escapeRegExp(this.options.path)}`);

				if (href.match(pattern)) {
					// Assistant links
					event.preventDefault();

					this.router.navigate(href);
				} else if (href.match(/^\//)) {
					// Application links
					event.preventDefault();

					window.open(`${this.options.url}${href}`, '_blank');
				}
			}
		});
	}

	/**
	 * Load content via API and insert into DOM
	 * URLs are transformed if they match our routing
	 * @param {String} path
	 */
	async load(path) {
		this.element.classList.add('is-loading');

		const filteredPath = (path || this.options.path).replace(/^\//, '');
		const url = `${this.options.url}/${filteredPath}?api=true&lang=${this.options.locale}`;

		const html = await fetch(url)
			.then(response => response.text())
			.catch(console.log);

		// Show error
		if (!html) {
			this.element.innerHTML = this.options.error;

			this.element.classList.remove('is-loading');

			return;
		}

		// Prefix some URLs
		const filtered = html.replace(/('|")\/api\//g, `$1${this.options.url}/api/`);

		// Insert markup
		this.element.innerHTML = filtered;

		// Init components
		this.element.querySelectorAll('[data-init~="status"]').forEach(element => {
			initStatus(element);
		});
		this.element.querySelectorAll('[data-init~="paragraph"]').forEach(element => {
			initParagraph(element);
		});
		this.element.querySelectorAll('[data-init~="search"]').forEach(element => {
			initSearch(element);
		});

		// Init form fields
		if (window.LN && window.LN.initCustomFields) {
			window.LN.initCustomFields(this.element);
		}

		// Remove overlay
		this.element.classList.remove('is-loading');
	}
}

// Init assistant
const elements = document.querySelectorAll('[data-app="assistant"]');

elements.forEach(element => {
	const url = element.dataset.url;
	const path = element.dataset.path;
	const error = element.dataset.error;
	const locale = element.dataset.locale;

	new Assistant(element, {
		url,
		path,
		error,
		locale
	});
});
